import { ApolloClient, InMemoryCache } from '@apollo/client';
import { ApolloLink } from '@apollo/client/link';
import { HttpLink } from '@apollo/client/link/http';
import { RetryLink } from '@apollo/client/link/retry';
import { useMemo } from 'react';

const API_VERSION = '2026-01';

export default function ShopifyCachedApolloClient() {
  const client = useMemo(() => {
    const cache = new InMemoryCache({
      typePolicies: {
        Cart: {
          fields: {
            lines: {
              keyArgs: false,
              merge(existing = { edges: [] }, incoming) {
                return {
                  edges: incoming.edges || [],
                  __typename: incoming.__typename,
                };
              },
            },
          },
        },
      },
    });

    const link = ApolloLink.from([
      new RetryLink(),
      new HttpLink({
        headers: {
          'X-Shopify-Storefront-Access-Token': SHOPIFY_KEY,
        },
        uri: `https://${SHOPIFY_CUSTOM_DOMAIN}/api/${API_VERSION}/graphql.json`,
      }),
    ]);

    return new ApolloClient({
      link,
      cache,
      defaultOptions: {
        watchQuery: {
          fetchPolicy: 'cache-and-network',
        },
      },
    });
  }, []);

  return client;
}
